import { Box } from '@mui/material';

export default function MainLayout({ children }) {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundImage: "url('/rapbazzar-bg.png')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundColor: '#1A0834',
        py: { xs: 0.8, sm: 1, md: 1.2 },
      }}
    >
      <Box sx={{ width: '100%', maxWidth: 'none', p: 0, m: 0 }}>{children}</Box>
    </Box>
  );
}
